import { useMemo } from 'react';
import { Breadcrumb as AntdBreadcrumb } from 'antd';
import { Link } from "react-router-dom";
import "./index.scss";

interface BreadcrumbProp {
    breadcrumbs?: Array<any>
    collapsed?: boolean
}

const Breadcrumb = (props: BreadcrumbProp): any => {
    const { breadcrumbs, collapsed } = props;

    const items = useMemo(() => {
        return breadcrumbs?.map((e: any) => {
            return {
                title: e.path ? <Link to={e.path}>{e.name}</Link> : e.name,
            };
        }) || []
    }, [breadcrumbs])

    return (
        <AntdBreadcrumb className={collapsed ? "breadcrumb collapsed" : "breadcrumb"} items={items} />
    );
}

export default Breadcrumb;
